<template>
  <div id="app">
    <main>
      <router-view></router-view> <!-- Add this to render routed pages -->
    </main>
  </div>
</template>

<script>


export default {
  name: "App",
};
</script>
